<div class="page-container">

    <!-- HEADER -->
    <div class="d-flex align-items-center mb-4">
        <span class="me-2 fs-4 cursor-pointer">&larr;</span>
        <h4 class="back-title mb-0">Gatepass Student Outing</h4>
    </div>

    <!-- TOP BAR -->
    <div class="card-box mb-3">
        <div class="d-flex justify-content-between align-items-center">

            <!-- LEFT SIDE -->
            <div class="d-flex align-items-center gap-2">
                <label class="mb-0">Show</label>
                <select class="form-select page-size-select"
                        [(ngModel)]="pageSize"
                        (change)="onPageSizeChanged()">
                    <option [value]="25">25</option>
                    <option [value]="50">50</option>
                    <option [value]="100">100</option>
                </select>
            </div>

            <!-- RIGHT SIDE -->
            <div class="d-flex align-items-center gap-2">

                <!-- SCAN BUTTON -->
                <button class="btn btn-outline-primary"
                        title="Scan QR"
                        (click)="openScanner()">
                    📷 Scanner
                </button>

                <!-- SEARCH -->
                <input type="text"
                       class="form-control"
                       style="width:220px"
                       placeholder="Search"
                       [(ngModel)]="searchText">
            </div>

        </div>
    </div>

    <!-- AG GRID -->
    <ag-grid-angular
        class="ag-theme-alpine w-100 ag-grid-height"
        [rowData]="rowData"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [pagination]="true"
        [paginationPageSize]="pageSize"
        [animateRows]="true"
        [quickFilterText]="searchText"
        (gridReady)="onGridReady($event)">
    </ag-grid-angular>

    <!-- 🔥 SCANNER FLOATING PANEL (OUTSIDE GRID FLOW) -->
    <div *ngIf="showScanner" class="qr-panel">
        <div class="d-flex justify-content-between align-items-center mb-2">
            <strong>Scan QR</strong>
            <button class="btn btn-sm btn-danger" (click)="closeScanner()">✖</button>
        </div>

        <div id="qr-reader"></div>
    </div>

</div>
